import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseMessageBusService } from '../../commons/services/base-message-bus.service';
import { LangEnum } from '../../commons/enums/langs.enum';
import { EventsConstants } from '../../commons/constants/event-constants';
import { BaseLocalStorageService } from '../../commons/services/base-local-storage.service';
import { LocalStorageConstants } from '../../commons/constants/local-storage-constants';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/**
 * Clase para todo lo general que no tiene que ver con módulos que podrían ser migrados a microfrontend en un futuro
*/
export class BaseTranslateService {        
    
    private _onChangeLang: Subject<string> = new Subject();

    constructor (
        private _messageBusService: BaseMessageBusService,
        private _baseLocalStorageService: BaseLocalStorageService,
        private  _translateService: TranslateService
    ) {
        this.defineLanguage();
    }

    getText(key: string): string {
        return this._translateService.instant(key);
    }

    async getTextAsync(key: string): Promise<string> {
        return await this._translateService.get(key).toPromise();
    }

    getTextObservable(key: string): Observable<string>  {
        return this._translateService.get(key);
    }

    setLangEs(): void {
        this.changeLanguage(LangEnum.ES, true);
    }

    setLangEn(): void {
        this.changeLanguage(LangEnum.EN, true);
    }

    public onChangeLanguage(): Observable<string> {
        return this._onChangeLang.asObservable();
    }


    private changeLanguage(lang: LangEnum, send: boolean = false): void {
        if(this._translateService.defaultLang !== lang){
            this._translateService.setDefaultLang(lang);
            this._onChangeLang.next(lang);
            
            if(!send) return;
            this._messageBusService.dispatchEventWithData(EventsConstants.CHANGE_EXTERNAL_LANGUAGE, lang);
        }
    }
    
    private defineLanguage(): void {
        const langs:string[] = this._baseLocalStorageService.getObject(LocalStorageConstants.Langs);        
        let currentLang :string= this._baseLocalStorageService.getString(LocalStorageConstants.CurrentLang).toString()||LangEnum.EN;
        this._translateService.addLangs(langs);
        if (!langs.find(lang => lang == currentLang)) return this._translateService.setDefaultLang(LangEnum.EN);

        this._translateService.setDefaultLang(currentLang);
        
    }

}